import React from "react";
import price from "../../assets/Toyota-Supra-2020-PNG-Images-HD.png";
import price1 from "../../assets/MOT_XB1_Dodge_Charger_68_FF 1.png";
import price2 from "../../assets/purepng.com-lexus-gs-blue-carcarvehicletransportlexus-961524655897bccc9 1.png";
import price3 from "../../assets/2-25507_green-lamborghini-png-lamborghini-aventador-green-png-transparent 1.png";
import icici from "../../assets/ICICI.png";
import axis from "../../assets/axis.png";
import hdfc from "../../assets/hdfc.webp";
import kotak from "../../assets/kotak.png";
// import g from "../../assets/g.png";
import "@fontsource/barlow-condensed";
import "@fontsource/barlow-condensed/400.css";
import "@fontsource/barlow-condensed/400-italic.css";
import "../../index.css";

const Main = () => {
  return (
    <>
      <div className="text-center leading-normal md:gap-6 flex flex-col items-center mt-6 sm:mt-16 self-stretch sm:mb-8">
        <h2
          className="font-normal text-xl md:text-5xl text-black leading-normal w-11/12 md:w-4/5"
          style={{ fontFamily: "Ballega" }}
        >
          Sell And Buy Your Car In Hyderabad at Best Price
        </h2>
        <p
          className="text-black text-base md:text-2xl font-normal leading-normal w-11/12 md:w-4/5"
          style={{ fontFamily: "Barlow Condensed" }}
        >
          Hyderabad’s trusted car marketplace! Get up to{" "}
          <span className="text-2xl font-bold">90%</span> loan with just a{" "}
          <span className="text-2xl font-bold">5%</span> down payment. Buy or
          sell your car easily with verified listings and the best deals. Fast,
          reliable, and hassle-free—join thousands in the City of Pearls today!
        </p>
        <div className="py-8">
          <p
            className="font-normal text-3xl text-black leading-normal pb-8"
            style={{ fontFamily: "Ballega" }}
          >
            Our Banking Partners
          </p>
          <dl className="grid grid-cols-2 md:grid-cols-4 gap-4 items-center px-6 lg:px-0">
            <img src={axis} alt="Axis Bank Logo" className="w-48 h-auto" />
            <img src={hdfc} alt="HDFC Bank Logo" className="w-48 h-auto" />
            <img src={kotak} alt="Kotak Bank Logo" className="w-48 h-auto" />
            {/* <img
              src={g}
              alt="Gadiwale Logo"
              className="w-24 md:w-48 md:h-48 rounded-xl"
            /> */}
            <img
              src={icici}
              alt="ICICI Bank Logo"
              className="w-48 h-auto"
            />
          </dl>
        </div>
      </div>
      <div
        className="text-black text-center text-3xl leading-normal flex flex-col gap-9 px-6 sm:px-16 sm:mb-20"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        <h3 className="text-3xl" style={{ fontFamily: "Ballega" }}>
          Process Of Selling and Buy Used Cars
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-5 text-white">
          <section className="relative flex flex-col gap-12 bg-red-600 p-6 pb-32 sm:pb-16 lg:pb-24 hover:shadow-[0px_0px_8px_4px_rgba(220,38,38,_0.45)] transition-shadow duration-600 ease-in-out">
            <div className="relative mt-9">
              <h4
                className="text-3xl font-normal"
                style={{ fontFamily: "Ballega" }}
              >
                Good Price
              </h4>
              <p className="text-base font-normal">
                Get the best price for your dream car! Whether you're looking for a budget-friendly option or a premium ride, we offer unbeatable deals. Transparent pricing, no hidden fees, and top-quality vehicles. Compare, choose, and drive away with confidence. Find your perfect car at the best value today!
              </p>
            </div>
            <div className="relative">
              <h2
                className="text-9xl font-bold"
                style={{ fontFamily: "Built Titling" }}
              >
                SALE
              </h2>
              <img src={price} alt="price" className="absolute top-24" />
            </div>
          </section>
          <section className="relative flex flex-col gap-12 bg-gray-600 p-6 pb-32 hover:shadow-[0px_0px_8px_4px_rgba(75,85,99,_0.55)] transition-shadow duration-600 ease-in-out">
            <div className="relative mt-9">
              <h4
                className="text-3xl font-normal"
                style={{ fontFamily: "Ballega" }}
              >
                Car Inspection
              </h4>
              <p className="text-base font-normal">
                Regular car inspection ensures your vehicle's safety, performance, and longevity. Key checks include engine oil, brakes, tire pressure, battery health, and fluid levels. Regular maintenance prevents costly repairs and breakdowns. A well-maintained car ensures a smooth and safe drive.
              </p>
            </div>
            <div className="relative">
              <h2
                className="text-9xl font-bold"
                style={{ fontFamily: "Built Titling" }}
              >
                CARE
              </h2>
              <img src={price1} alt="price1" className="absolute top-20" />
            </div>
          </section>
          <section className="relative flex flex-col gap-4 bg-blue-400 p-6 pb-40 sm:pb-16 lg:pb-24 hover:shadow-[0px_0px_8px_4px_rgba(96,165,250,_0.45)] transition-shadow duration-600 ease-in-out">
            <div className="relative mt-9">
              <h4
                className="text-3xl font-normal"
                style={{ fontFamily: "Ballega" }}
              >
                Car pick up & payment
              </h4>
              <p className="text-base font-normal">
                We ensure a seamless and hassle-free car pickup process at your convenience. Every transaction is transparent, ensuring complete trust and reliability. Our team verifies every detail to provide a smooth experience. Rest assured, your car pickup and payment are handled with professionalism and care.
              </p>
            </div>
            <div className="relative">
              <h2
                className="text-9xl font-bold"
                style={{ fontFamily: "Built Titling" }}
              >
                TRUST
              </h2>
              <img src={price2} alt="price2" className="absolute top-20" />
            </div>
          </section>
          <section className="relative flex flex-col gap-8 bg-emerald-600 p-6 pb-32 hover:shadow-[0px_0px_8px_4px_rgba(5,150,105,_0.45)] transition-shadow duration-600 ease-in-out">
            <div className="relative mt-9">
              <h4
                className="text-3xl font-normal"
                style={{ fontFamily: "Ballega" }}
              >
                Financial Help
              </h4>
              <p className="text-base font-normal">
                We provide loan assistance through partnered banks to help you finance your car easily. Our team guides you in choosing the best loan with low interest rates and flexible repayment options. We ensure a smooth and hassle-free approval process. Let us help you drive your dream car today!
              </p>
            </div>
            <div className="relative mt-5 xl:mt-0">
              <h2
                className="text-9xl font-bold"
                style={{ fontFamily: "Built Titling" }}
              >
                FUNDS
              </h2>
              <img
                src={price3}
                alt="price3"
                className="absolute top-16 ml-10 w-64 h-48"
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Main;
